export default function ScoreCardMetric({ label, value, detail, accent = false }) {
  return (
    <article className={`scorecard-metric${accent ? ' scorecard-metric--accent' : ''}`}>
      <div className="scorecard-metric__label">{label}</div>
      <div className="scorecard-metric__value">{value}</div>
      {detail && <div className="scorecard-metric__detail">{detail}</div>}
    </article>
  );
}
